<template>

	<div v-if="nopopup" class="d-inline-block">
		<span v-if="fulladdress">{{ address }}</span>
		<span v-else>{{ shortAddress }}</span>
		<v-btn icon v-if="accounturl" :href="accounturl + address" target="_blank">
			<v-icon>mdi-open-in-new</v-icon>
		</v-btn>
		<v-chip v-if="markself && isMyself"
		v-bind:class="{'green lighten-3': !$vuetify.theme.dark, 'green darken-4': $vuetify.theme.dark }"
			class="ml-1" small text-color="white"
		>
			<v-avatar left>
				<v-icon small color="white">mdi-account-circle</v-icon>
			</v-avatar>
			<span>{{ $t('common.noun.me') }}</span>
		</v-chip>
	</div>

	<div v-else class="d-inline-block">
		<v-tooltip bottom>
			<template v-slot:activator="{ on }">
				<span v-if="fulladdress" v-on="on">{{ address }}</span>
				<span v-else v-on="on">{{ shortAddress }}</span>
			</template>
			<div>
				{{ address }}
			</div>
		</v-tooltip>
		<v-btn icon small v-if="accounturl" :href="accounturl + address" target="_blank">
			<v-icon small>mdi-open-in-new</v-icon>
		</v-btn>
		<v-chip v-if="markself && isMyself"
			v-bind:class="{'green lighten-3': !$vuetify.theme.dark, 'green darken-4': $vuetify.theme.dark }"
			class="ml-1" small text-color="white"
		>
			<v-avatar left>
				<v-icon small color="white">mdi-account-circle</v-icon>
			</v-avatar>
			<span>{{ $t('common.noun.me') }}</span>
		</v-chip>
	</div>

</template>

<script>

export default {
	name: 'UserAddress',
	props: {
		address: { type: String },
		accounturl: { type: String },
		myaddress: { type: String },
		nopopup: { type: Boolean, default: false },
		fulladdress: { type: Boolean, default: false },
		markself: { type: Boolean, default: false },
	},
	data () {
		return {}
	},
	computed: {
		shortAddress: function () {
			const frontToKeep = 6
			const endToKeep = 4
			const endIndexStart = this.address.length - endToKeep
			return this.address.substring(0, frontToKeep) + '...' + this.address.substring(endIndexStart)
		},
		isMyself: function () {
			return this.address && this.myaddress && this.address.toLowerCase() === this.myaddress.toLowerCase()
		}
	},
	methods: {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
